import script from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"

import "./UserBadge.vue?vue&type=style&index=0&id=58a7f00b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a7f00b"]])

export default __exports__